import { render, staticRenderFns } from "./ServidorPublicoFederal.vue?vue&type=template&id=5b41577e"
import script from "./ServidorPublicoFederal.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoFederal.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoFederal.vue?vue&type=style&index=0&id=5b41577e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports